import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  fontFamily: "字体",
  fontSize: "字体大小",
  fontStyle: "字体样式",
  lineHeight: "行高",
  fontWeight: "字重",
  minFontSize: "字号最小值",
  maxFontSize: "字号最大值",
  animateRotate: "旋转角度",
  animateSpeed: "旋转频率",
  isAnimate: "旋转效果",
  colorList: "字体颜色列表",
  updateTimer: "数据源轮询时间",
  restDataUrl: "外接数据源地址",
  "cloudDatas.0.link": "外链地址",
  "cloudDatas.0.name": "名称"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
